<template>
  <div class="drag">
    <slot name="line-top"> </slot>
    <div class="edge-line" @mousedown.stop.prevent="moveVertical"></div>
    <slot name="line-bottom"> </slot>
  </div>
</template>

<script>
import { windowResize } from '@/utils/helpers';
export default {
  name: 'DragLine',
  props: {
    calcOutputAreaHeight: {
      type: Number
    },
    pageSize: {
      type: Object
    }
  },
  mounted() {
    windowResize(() => {
      if (this.pageSize.command > document.documentElement.clientHeight - 150)
      {
        this.pageSize.command = document.documentElement.clientHeight - 150;
      }
    });
  },
  methods: {
    moveVertical(e) {
      let oDiv = e.target; // 获取目标元素
      //计算出鼠标相对点击元素的位置,e.clientX获取的是鼠标的位置，OffsetLeft是元素相对于外层元素的位置
      let y = e.clientY - oDiv.offsetTop;
      let tempOffsetTop = oDiv.offsetTop;
      let tempCommand = this.pageSize.command;
      document.onmousemove = e => {
        // 获取拖拽元素的位置
        let top = e.clientY - y;
        if (top <= 5) {
          top = 5;
        } else if (top >= document.documentElement.clientHeight - 150) {
          // document.documentElement.clientHeight 屏幕的可视高度
          top = document.documentElement.clientHeight - 150;
        }
        this.pageSize.command = tempCommand - (tempOffsetTop - top);
      };

      // 为了防止 火狐浏览器 拖拽阴影问题
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.drag {
  position: relative;
}
.edge-line {
  width: 100%;
  height: 4px;
  cursor: s-resize;
  background-color: #e6e8ec;
  z-index: 9999;
}
</style>
